import {createRouter} from '@ionic/vue-router';
import TabsPage from '../views/indexPage.vue'
import {createWebHashHistory} from "vue-router";

const routes = [
    {
        path: '/',
        redirect: '/tabs/home'
    },
    {
        path: '/login',
        component: () => import('@/views/loginPage.vue')
    },
    {
        path: '/register',
        component: () => import('@/views/registerPage.vue')
    },
    {
        path: '/type',
        component: () => import('@/views/home/typePage.vue')
    },
    {
        path: '/sign',
        component: () => import('@/views/mine/signPage.vue')
    },
    {
        path: '/policyEnter',
        component: () => import('@/views/mine/policyEnterPage.vue')
    },
    {
        path: '/recommend',
        component: () => import('@/views/mine/recommendPage.vue')
    },
    {
        path: '/underNode',
        component: () => import('@/views/mine/underNodePage.vue')
    },
    {
        path: '/userMsg',
        component: () => import('@/views/mine/userMsgPage.vue')
    },
    {
        path: '/system',
        component: () => import('@/views/mine/systemPage.vue')
    },
    {
        path: '/userInfo',
        component: () => import('@/views/mine/userInfoPage.vue')
    },
    {
        path: '/updatePassWord',
        component: () => import('@/views/mine/updatePassWordPage.vue')
    },
    {
        path: '/updatePayPassWord',
        component: () => import('@/views/mine/updatePayPassWordPage.vue')
    },
    {
        path: '/autonomy',
        component: () => import('@/views/mine/autonomyPage.vue')
    },

    {
        path: '/bindHost',
        component: () => import('@/views/mine/bindHostPage.vue')
    },

    {
        path: '/forgetPassWord',
        component: () => import('@/views/forgetPassWordPage.vue')
    },
    {
        path: '/mineOrder',
        component: () => import('@/views/mine/mineOrderPage.vue')
    },
    {
        path: '/policyDetails/:policyId',
        component: () => import('@/views/mine/policyDetailsPage.vue')
    },
    {
        name: '/softwarePage',
        path: '/softwarePage',
        component: () => import('@/views/home/softwarePage.vue')
    },
    {
        path: '/userMoney',
        component: () => import('@/views/mine/userMoneyPage.vue')
    },
    {
        path: '/moneyDetails',
        component: () => import('@/views/mine/moneyDetailsPage.vue')
    },
    {
        path: '/fycList',
        component: () => import('@/views/mine/fycListPage.vue')
    },
    {
        name: "userLevel1Apply",
        path: '/userLevel1Apply',
        component: () => import('@/views/mine/userLevel1Apply.vue')
    },
    {
        path: '/privacyPolicy',
        component: () => import('@/views/privacyPolicyPage.vue')
    },
    {
        path: '/workRoom',
        component: () => import('@/views/mine/workRoomPage.vue')
    },
    {
        path: '/saleEnter',
        component: () => import('@/views/mine/saleEnterPage.vue')
    },
    {
        path: '/workMoney',
        component: () => import('@/views/mine/workMoneyPage.vue')
    },
    {
        path: "/userTrainMoney",
        component: () => import('@/views/mine/userTrainMoneyPage.vue')
    },
    {
        path: '/myCode',
        component: () => import('@/views/mine/myCodePage.vue')
    },
    {
        path: '/registerUser',
        component: () => import('@/views/mine/registerUser.vue')
    },
    {
        name: "newList",
        path: '/newList',
        component: () => import('@/views/home/newList.vue')
    },
    {
        name: "newDetail",
        path: '/newDetail',
        component: () => import('@/views/home/newDetail.vue')
    },
    {
        name: "videoPlay",
        path: '/videoPlay',
        component: () => import('@/views/video/videoPlay.vue')
    },
    {
        name: "userVideo",
        path: '/userVideo',
        component: () => import('@/views/video/userVideoPage.vue')
    },
    {
        name: "videoUp",
        path: '/videoUp',
        component: () => import('@/views/video/videoUpPage.vue')
    },
    {
        name: "livePlay",
        path: '/livePlay',
        component: () => import('@/views/video/livePlay.vue')
    },
    {
        name: "carInsuracne",
        path: '/carInsuracne',
        component: () => import('@/views/home/carInsurance.vue')
    },
    {
        name: "uploadCarInfo",
        path: '/uploadCarInfo',
        component: () => import('@/views/home/uploadCarInfo.vue')
    },
    {
        name: "userCarInfoList",
        path: '/userCarInfoList',
        component: () => import('@/views/home/userCarInfoList.vue')
    },
    {
        name: "userCarCompanyDetail",
        path: '/userCarCompanyDetail',
        component: () => import('@/views/home/userCarCompanyDetail.vue')
    },
    {
        name: "chatMsg",
        path: '/chatMsg',
        meta: {
            keepAlive: true
        },
        component: () => import('@/views/chat/chatMsg.vue')
    },
    {
        name: "successPage",
        path: '/successPage',
        component: () => import('@/views/home/successPage.vue')
    },

    {
        name: "productDetail",
        path: '/productDetail/:productId',
        component: () => import('@/views/product/productDetails.vue')
    }, {
        name: "productTypeList",
        path: '/productTypeList',
        component: () => import('@/views/product/typeList.vue')
    }, {
        name: "productListTab",
        path: '/productListTab',
        component: () => import('@/views/product/listTab.vue')
    },
    {
        name: "paySuccess",
        path: '/paySuccess',
        component: () => import('@/views/cart/paySuccess.vue')
    }, {
        name: "cartSubmit",
        path: '/cartSubmit',
        component: () => import('@/views/cart/cartSubmit.vue')
    }, {
        name: "cartSpcart",
        path: '/cartSpcart',
        component: () => import('@/views/cart/cartSpcart.vue')
    },
    {
        name: "addressList",
        path: '/addressList',
        component: () => import('@/views/addres/addressList.vue')
    },
    {
        name: "orderTab",
        path: '/orderTab',
        component: () => import('@/views/order/orderTab.vue')
    },
    {
        name: "privatePolicy",
        path: '/privatePolicy',
        component: () => import('@/views/home/privatePolicy.vue')
    },
    {
        name: "transferTotalAllowance",
        path: '/transferTotalAllowance',
        component: () => import('@/views/mine/transferAllowancePage.vue')
    },
    {
        name: 'applyInvoicing',
        path: '/applyInvoicing',
        component: () => import('@/views/mine/applyInvoicing.vue')
    },
    {
        name: 'applyInvoicingList',
        path: '/applyInvoicingList',
        component: () => import('@/views/mine/applyInvoicingList.vue')
    },

    {
        name: 'clothingOrder',
        path: '/clothingOrder',
        component: () => import('@/views/home/clothingOrder.vue')
    },
    {
        name: 'clothingOrderList',
        path: '/clothingOrderList',
        component: () => import('@/views/home/clothingOrderList.vue')
    },
    {
        name: 'userRegionApply',
        path: '/userRegionApply',
        component: () => import('@/views/mine/userRegionApply.vue')
    },
    {
        name: 'insuranceConsuling',
        path: '/insuranceConsuling',
        component: () => import('@/views/home/insuranceConsuling.vue')
    },
    {
        name: 'insuranceConsulingList',
        path: '/insuranceConsulingList',
        component: () => import('@/views/home/insuranceConsulingList.vue')
    },
    {
        path: '/tabs/',
        component: TabsPage,
        children: [
            {
                path: '',
                redirect: '/tabs/home'
            },
            {
                path: 'home',
                component: () => import('@/views/homePage.vue')
            },
            {
                path: 'video',
                component: () => import('@/views/videoPage.vue')
            },
            {
                path: 'newsTabs',
                component: () => import('@/views/news/newsTabs.vue')
            },
            {
                path: 'mine',
                component: () => import('@/views/minePage.vue')
            }
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
